import { qSetReportCount } from "../../../../api/report";
import { qSetReport } from "../../../../api/report";
import { toast } from "react-toastify";

export async function qSetReportSubmit(
  setSubmitLoading,
  setNoData,
  formData,
  setNumberOfQSetReports,
  setQSetReportList,
  limit,
  offSet,
  setStartUpLoad
) {
  setNumberOfQSetReports(0);
  setQSetReportList([])
  setSubmitLoading(true);
  setNoData(false);
  const link = [];
  link.push(`limit=${limit}`);
  link.push(`offset=${offSet}`);
  if(formData.medium_id && formData.medium_id !== -1){
    link.push(`medium_id=${formData.medium_id}`)
  }
  if (formData.board_id && formData.board_id !== -1) {
    link.push(`board_id=${formData.board_id}`);
  }
  if (formData.course_id && formData.course_id !== -1) {
    link.push(`course_id=${formData.course_id}`);
  }
  if (formData.subject_id && formData.subject_id !== -1) {
    link.push(`subject_id=${formData.subject_id}`);
  }
  if(formData.sub_subject_id && formData.sub_subject_id !== -1){
    link.push(`sub_subject_id=${formData.sub_subject_id}`)
  }
  if (formData.topic_id && formData.topic_id !== -1) {
    link.push(`topic_id=${formData.topic_id}`);
  }
  if(formData.from_date){
    link.push(`from_date=${formData.from_date}`)
  }
  if(formData.to_date){
    link.push(`to_date=${formData.to_date}`)
  }
  const linkFinal = link.join("&");
  console.log(linkFinal);
  try {
    const getQSetReportCount = await qSetReportCount(linkFinal);
    console.log(getQSetReportCount.data.data.count);
    setNumberOfQSetReports(getQSetReportCount.data.data.count);
    if (getQSetReportCount.data.data.count !== 0) {
      const getQSetReport = await qSetReport(linkFinal);
      console.log(getQSetReport.data.data);
      setQSetReportList(getQSetReport.data.data);
      setSubmitLoading(false);
      setStartUpLoad(false);
      window.scrollTo(0, 1000);
    } else {
      setNoData(true);
      setSubmitLoading(false);
      setStartUpLoad(false);
    }
  } catch (error) {
    if (error.response && error.response.data) {
      console.log(error.response.data.message);
      toast.error(error.response.data.message);
    } else {
      toast.error("Server Error");
    }
    setSubmitLoading(false);
    setStartUpLoad(false);
  }
}
